/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-15 08:18:35 */

const Keys = {
  titleExpired: 'titleExpired',
  titleIsAboutToExpire: 'titleIsAboutToExpire',
  sessionExpiredText: 'sessionExpiredText',
  sessionIsAboutToExpire: 'sessionIsAboutToExpire',
  buttonExpired: 'buttonExpired',
  buttonRefresh: 'buttonRefresh'
}; export default Keys;